import { PaymentPlatform } from '@utriper/core';
import { AccountBalance, Link, LocalAtm, Payment, PendingActions, PointOfSale } from '@mui/icons-material';
import { alpha } from '@mui/material';

export const getPaymentPlatformIcon = (paymentPlatformId, disabled = false) => {
    const { IDS } = PaymentPlatform;
    const opacity = disabled ? 0.75 : 1;

    switch (paymentPlatformId) {
        case IDS.undefined:
            return <PendingActions sx={{ color: alpha('#E4954B', opacity) }} />;
        case IDS.OperatorCash:
        case IDS.cash:
            return <LocalAtm sx={{ color: alpha('#50C878', opacity) }} />;
        case IDS.OperatorTerminal:
        case IDS.terminal:
            return <PointOfSale sx={{ color: alpha('#FACE5D', opacity) }} />;
        case IDS.link:
            return <Link sx={{ color: alpha('#137DC5', opacity) }} />;
        case IDS.OperatorTransfer:
        case IDS.transfer:
            return <AccountBalance sx={{ color: alpha('#A5BA63', opacity) }} />;
        case IDS.stripe:
            return <Payment sx={{ color: alpha('#9EC4D6', opacity) }} />;
        default:
            return <LocalAtm sx={{ color: alpha('#50C878', opacity) }} />;
    }
};

export const getPaymentPlatformsFormatted = (paymentPlatforms, language) => {
    return paymentPlatforms.map(({ id }) => ({
        id,
        name: PaymentPlatform.getTranslatedName(PaymentPlatform.types, id, language)?.[0],
        // description: PaymentPlatform.getTranslatedDesc(PaymentPlatform.types, paymentPlatformId, language),
    }));
};

export const paymentDialogPlatforms = [PaymentPlatform.IDS.OperatorCash, PaymentPlatform.IDS.cash, PaymentPlatform.IDS.OperatorTerminal, PaymentPlatform.IDS.terminal, PaymentPlatform.IDS.OperatorTransfer, PaymentPlatform.IDS.transfer];
